module.exports = __webpack_public_path__ + "assets/img/6.f634e9bc.png";